import React from 'react';
import { Box, Typography } from '@mui/material';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import StyleIcon from '@mui/icons-material/Style';
import SearchIcon from '@mui/icons-material/Search';
import ForestIcon from '@mui/icons-material/Forest';
import { useTranslation } from 'react-i18next';
import myClosetVideo from '../myClosetVideo.mp4';


const AboutUs = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Box sx={{ backgroundColor: 'black', padding: '2rem', mb: 3, textAlign: 'center', fontStyle: 'oblique' }}>
        <Typography variant="h6" sx={{ color: 'white' }}>
          {t('aboutUs.title')}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', align: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <video style={{ width: "20rem" }} alt="MyClosetVideo" src={myClosetVideo} muted controls autoPlay loop />
        </Box>
        <Box>
          <Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <CameraAltIcon sx={{ fontSize: '5rem' }} />
                <Typography variant="h5">
                  Outfits
                </Typography>
                <Typography variant="body2">
                  {t('aboutUs.outfits')}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <StyleIcon sx={{ fontSize: '5rem' }} />
                <Typography variant="h5" >
                  Tags
                </Typography>
                <Typography variant="body2">
                  {t('aboutUs.tags')}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <SearchIcon sx={{ fontSize: '5rem' }} />
                <Typography variant="h5" >
                  {t('aboutUs.filter')}
                </Typography>
                <Typography variant="body2">
                  {t('aboutUs.filterBody')}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', mb: 3 }}>
                <ForestIcon sx={{ fontSize: '5rem' }} />
                <Typography variant="h5" >
                  {t('aboutUs.environment')}
                </Typography>
                <Typography variant="body2">
                  {t('aboutUs.environmentBody')}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Box sx={{ backgroundColor: 'black', padding: '2rem', mb: 3, textAlign: 'center', fontStyle: 'oblique' }}>
        <Typography variant="h6" sx={{ color: 'white' }}>
          Support: 🦄 ccastromn@gmail.com
        </Typography>
      </Box>
    </Box>
  );
};

export default AboutUs;
